import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./productionOrderSapExtraInfoForm.data.form";
import InputText from "../../../utils/InputText";

const ProductionOrderSapForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onBack, onSave } = props;

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {t("forms.productionOrderSap.titleExtraInfo")}
          </h3>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="hourMen"
                  className="form-control"
                  labelField={t("forms.productionOrderSap.labels.hourMen")}
                  name="hourMen"
                  component={InputText}
                  fieldType="number"
                  placeholder=""
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="stopTime"
                  className="form-control"
                  labelField={t("forms.productionOrderSap.labels.stopTime")}
                  name="stopTime"
                  component={InputText}
                  fieldType="number"
                  placeholder=""
                  mandatory
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-3">
                <button
                  type="button"
                  onClick={() => onBack()}
                  className="btn btn-md btn-secondary me-2"
                >
                  {t("forms.productionOrderSap.buttons.cancel")}
                </button>
                <button
                  type="button"
                  onClick={() => onSave(props.values)}
                  className="btn btn-md btn-primary me-2"
                >
                  {t("forms.productionOrderSap.buttons.save")}
                </button>
                <button type="submit" className="btn btn-md btn-primary">
                  {t("forms.productionOrderSap.buttons.saveAndFinish")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

ProductionOrderSapForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onBack: PropTypes.func,
  onSave: PropTypes.func,
};

const ProductionOrderSapFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ProductionOrderSapForm",
})(ProductionOrderSapForm);

export default ProductionOrderSapFormF;
